import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { DO_NOT_CHANGE_NO_CLIENT_VERSION, DO_NOT_CHANGE_NUM_RETRIES, DO_NOT_CHANGE_TIMEOUT, REASON, } from '#pplx/frontend/apps/ask/finance/queries/constants.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { financeClient } from '#pplx_generated/typespec/rest/finance/client.js';
export const getPolymarketTrendingMarketsTickerKey = (symbol, withCommentary) => {
    return QueryClientHelper.makeEphemeralQueryKey('/rest/finance/prediction-markets/{market_identifier}/trending-ticker', symbol, withCommentary);
};
export async function getPolymarketTrendingMarketsTicker({ symbol, withCommentary = false, }) {
    const { data, error, response } = await financeClient.GET('/rest/finance/prediction-markets/{market_identifier}/trending-ticker', REASON, {
        params: {
            path: {
                market_identifier: symbol,
            },
            query: {
                with_commentary: withCommentary,
            },
        },
        timeoutMs: DO_NOT_CHANGE_TIMEOUT,
        numRetries: DO_NOT_CHANGE_NUM_RETRIES,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
export const getPredictionMarketsByTagKey = (tag, withCommentary, page, limit) => {
    return QueryClientHelper.makeEphemeralQueryKey('/rest/finance/prediction-markets/tag/{tag}', tag, withCommentary, page, limit);
};
export async function getPredictionMarketsByTag({ tag, withCommentary = false, page = 0, limit = 10, }) {
    const { data, error, response } = await financeClient.GET('/rest/finance/prediction-markets/tag/{tag}', REASON, {
        params: {
            path: {
                tag,
            },
            query: {
                with_commentary: withCommentary,
                page,
                limit,
            },
        },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
export const getPredictionMarketEventKey = ({ eventId, historyPeriod, marketsSort, withCommentary, emphasizedMarketIds, }) => {
    return QueryClientHelper.makeEphemeralQueryKey('/rest/finance/prediction-markets/quote/{event_id}', eventId, historyPeriod, marketsSort, withCommentary, emphasizedMarketIds);
};
export async function getPredictionMarketEvent({ eventId, historyPeriod, marketsSort = 'probability', withCommentary, emphasizedMarketIds, }) {
    const response = await financeClient.GET('/rest/finance/prediction-markets/quote/{event_id}', REASON, {
        params: {
            path: {
                event_id: eventId,
            },
            query: {
                history_period: historyPeriod,
                markets_sort: marketsSort,
                with_commentary: withCommentary,
                emphasized_market_ids: emphasizedMarketIds,
            },
        },
        timeoutMs: DO_NOT_CHANGE_TIMEOUT,
        numRetries: DO_NOT_CHANGE_NUM_RETRIES,
        shouldNotAddSourceVersionQueryParams: DO_NOT_CHANGE_NO_CLIENT_VERSION,
    });
    if (response.error) {
        throw new Error('Failed to fetch polymarket quote', {
            cause: response.error,
        });
    }
    return response.data;
}
export const getSearchPredictionMarketsKey = ({ query, }) => {
    return QueryClientHelper.makeEphemeralQueryKey('/rest/finance/prediction-markets/search', query);
};
export async function searchPredictionMarkets({ query, }) {
    if (!query.trim()) {
        return EMPTY_ARRAY;
    }
    const response = await financeClient.GET('/rest/finance/prediction-markets/search', REASON, {
        params: {
            query: {
                query,
            },
        },
        timeoutMs: DO_NOT_CHANGE_TIMEOUT,
        numRetries: DO_NOT_CHANGE_NUM_RETRIES,
        shouldNotAddSourceVersionQueryParams: DO_NOT_CHANGE_NO_CLIENT_VERSION,
    });
    if (response.error) {
        logger.error('Failed to search prediction markets', {
            error: response.error,
        });
        return EMPTY_ARRAY;
    }
    return response.data?.results ?? EMPTY_ARRAY;
}
//# sourceMappingURL=getPredictionMarkets.js.map